import React from 'react'

const { version, buildtimestamp, buildnumber, revision } = window.isbj.env || {}

export default function Footer() {
    return (
        <footer className="container-fluid">
            <small className="pl-3">
                {['ISBJ Dokumententresor Portal', version, buildnumber && `Build ${buildnumber}`, buildtimestamp, revision].filter(Boolean).join(' – ')}
            </small>
        </footer>
    )
}
